var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{ref:"counterFooterElement",staticClass:"counter-footer black-icons"},[_c('div',{staticClass:"content-container"},_vm._l((_vm.counters),function(counter){return _c('div',[_c('p',{staticClass:"counter"},[_vm._v(_vm._s(counter.score))]),_vm._v(" "),_c('p',{staticClass:"name",domProps:{"innerHTML":_vm._s(counter.title)}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }